import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './Button.scss';
import Spinner from '../Spinner';

function classList(classes) {
	return Object
		.entries(classes)
		.filter(entry => entry[1])
		.map(entry => entry[0])
		.join(' ');
}


const Button = (props) => {
	const {
		className,
		color,
		borderOnly,
		textOnly,
		showSpinner,
		children,
		icon,
		iconPosition,
		primary,
		secondary,
		...restProps
	} = props;
	const colorString = color?.toString() ?? 'default';
	const classes = classList({
		'primary': primary,
		'secondary': !primary && (secondary === undefined || secondary),
		'has-spinner': showSpinner,
		'no-children': !children
	});

	const Wrapper = useMemo(() => {
		return props.href  ? (wrapperProps) => <a {...wrapperProps} /> : (wrapperProps) => <button {...wrapperProps} />
	}, [props.href]);

	const iconLeft = icon && (iconPosition === 'left' || iconPosition === undefined) ? icon : null;
	const iconRight = icon && iconPosition === 'right' ? icon : null;

	return (
		<Wrapper
			className={`Button ${colorString} ${className ?? ''} ${classes}`}
			{...restProps}
		>
			<span className={'content'} key={'content'}>
				{iconLeft && <span key={'left'} className={'icon left'}>{iconLeft}</span>}
				{children && <span key={'text'}>{children}</span>}
				{iconRight && <span key={'right'} className={'icon right'}>{iconRight}</span>}
			</span>
			{showSpinner && <Spinner key={'spinner'} size='small' />}
		</Wrapper>
	);
};

Button.propTypes = {
	color: PropTypes.string,
	children: PropTypes.node,
	className: PropTypes.string,
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	icon: PropTypes.any,
	iconPosition: PropTypes.string,
	href: PropTypes.string,
	showSpinner: PropTypes.bool,
	primary: PropTypes.bool,
	type: PropTypes.string,
	//secondary: PropTypes.bool
};

export default Button;
